import FuseTheme from '../global/theme';

// Styles for Job Builder elements
export const jobBuilderStyles = {
    cardContainer: {minWidth: 800, margin: 0, padding: 0},
    card: {minHeight: 40, margin: '0 0 20px 0', padding: 8},
    cardHeader: {fontWeight: 600, margin: '-8px 0 0 0', padding: '11px 8px 4px 6px'},
    cardHeaderText: {padding: 0},
    cardText: {margin: 0, padding: '0 4px'},
    group: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: '10px 0 0 0'
    },
    button: {
        backgroundColor: '#e6ebf0',
        width: 'calc(50% - 22px - 1em)',
        margin: '0 1em 1em 0',
        padding: '12px 8px 10px 13px'
    },
    buttonIcon: {
        marginRight: 12,
        marginTop: 1
    },
    buttonName: {
        display: 'block',
        fontWeight: 600
    },
    buttonLabel: {
        display: 'block',
        marginTop: -4
    },
    dateFromToContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    error: {
        color: FuseTheme.palette.errorColor,
        margin: 0
    },
    inputContainer: {margin: '0 0 1em 0'},
    inputLabel: {marginLeft: 16},
    loading: {display: 'inline-block', margin: '0 0 0 16px'},
    message: {
        backgroundColor: FuseTheme.palette.accent2Color,
        fontSize: 18,
        margin: 0,
        padding: '10px 12px'
    },
    messageIcon: {
        display: 'inline-block',
        color: FuseTheme.palette.errorColor,
        margin: '0 6px -6px 0'
    },
    messageP: {
        margin: 0
    },
    reportChoice: {
        display: 'block',
        maxWidth: 'calc(100vw - 40px)',
        lineHeight: 1.4,
        whiteSpace: 'normal',
        margin: '0 0 4px 0',
        padding: 0
    },
    reportChoiceTitle: {
        display: 'inline-block',
        fontWeight: 600
    },
    reportChoiceDesc: {
        display: 'inline-block',
        margin: '0 0 0 8px'
    },
    reportChoiceLabel: {
        marginTop: -14
    }
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/styles-job-builder.js